import styled from "styled-components";
import { colors } from "../../../styles/variables";

export const StyledAutocompleteContainer = styled.div`
  position: relative;

  input {
    padding-left: 42px;
  }

  svg {
    position: absolute;
    top: 8px;
    left: 10px;
  }
`;

export const StyledSpinner = styled.div`
  position: absolute;
  top: 21px;
  left: 70px;
`;

// copied from react-select menu styles
export const StyledOptionListContainer = styled.div`
  top: 100%;
  background-color: hsl(0, 0%, 100%);
  border-radius: 4px;
  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);
  margin-bottom: 8px;
  margin-top: 8px;
  position: absolute;
  width: 100%;
  z-index: 1;
  overflow: hidden;
`;

// copied from react-select menuList styles
export const StyledOptionList = styled.div`
  max-height: 220px;
  overflow-y: auto;
  padding-bottom: 4px;
  padding-top: 4px;
  position: relative;

  & > div {
    padding: 8px 12px;
    cursor: pointer;
  }
`;

interface OptionProps {
  selectedItem: string;
  label: string;
  highlightedIndex: number;
  index: number;
}

export const StyledOption = styled.div<OptionProps>`
  padding: 8px 12px;
  cursor: pointer;

  ${({ selectedItem, label, highlightedIndex, index }) => `
    background-color: ${
      selectedItem === label
        ? colors.gray300
        : highlightedIndex === index
        ? "rgba(0, 0, 0, 0.15)"
        : "white"
    };
    color: ${selectedItem === label && "white"};
    ${
      selectedItem !== label &&
      `
      &:hover {
        background-color: rgba(0, 0, 0, 0.15);
      }
    `
    }
  `}
`;
